<template>
  <el-avatar v-if="hasImage" :size="size">
    <img class="profile-image" :src="src" alt="profile" />
  </el-avatar>
  <span
    v-else
    class="user-initials-avatar"
    :style="initialsStyle"
    role="img"
    :aria-label="fullName || 'Profile'"
    >{{ initials }}</span
  >
</template>

<script>
const DEFAULT_AVATAR = "default-user.png";

// Shows the user's uploaded picture, or their initials when they have none.
export default {
  name: "UserAvatar",
  props: {
    src: { type: String, default: "" },
    firstName: { type: String, default: "" },
    lastName: { type: String, default: "" },
    size: { type: Number, default: undefined },
  },
  computed: {
    hasImage() {
      return !!this.src && !this.src.includes(DEFAULT_AVATAR);
    },
    fullName() {
      return `${this.firstName || ""} ${this.lastName || ""}`.trim();
    },
    initials() {
      const first = (this.firstName || "").trim().charAt(0);
      const last = (this.lastName || "").trim().charAt(0);
      return (first + last).toUpperCase() || "U";
    },
    initialsStyle() {
      const size = this.size || 40;
      return {
        width: `${size}px`,
        height: `${size}px`,
        fontSize: `${Math.round(size * 0.4)}px`,
      };
    },
  },
};
</script>

<style lang="scss">
.user-initials-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #1b2459 0%, #1b2459 35%, #bf1b39 100%);
  color: #fff;
  font-weight: 600;
  line-height: 1;
  letter-spacing: 0.5px;
  user-select: none;
  vertical-align: middle;
}
</style>
